const producer = "https://images.unsplash.com/photo-1618414074972-723c8314d3db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxzb3VuZCUyMGVuZ2luZWVyJTIwbXVzaWMlMjBwcm9kdWNlciUyMHN0dWRpbyUyMGhlYWRwaG9uZXMlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODY5ODk2MjJ8MA&ixlib=rb-4.1.0&q=85";
const console_img = "https://images.unsplash.com/photo-1574517947730-55cb23e608c2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxtdXNpYyUyMG1peGluZyUyMHN0dWRpbyUyMGNvbnNvbGUlMjBwcm9kdWNlciUyMGFuYWxvZyUyMHN5bnRoJTIwZ2VhcnxlbnwwfHx8fDE3ODY5ODk2MTV8MA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16" data-testid="about-page">
      <div className="mono-caps mb-3">Hakkımda</div>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white max-w-3xl">
        Kulağa değil, <span className="gradient-text">duyguya</span> mix yaparım.
      </h1>

      <div className="grid md:grid-cols-12 gap-8 mt-12">
        <div className="md:col-span-5">
          <div className="panel overflow-hidden">
            <img src={producer} alt="producer" className="w-full h-[480px] object-cover" />
          </div>
        </div>
        <div className="md:col-span-7 space-y-6 text-slate-300 leading-relaxed">
          <p>
            10 yılı aşkın süredir profesyonel stüdyolarda mix ve mastering yapıyorum.
            Farklı türlerden 100&apos;den fazla albüm ve single üzerinde çalıştım — rock, pop, rap,
            elektronik ve akustik prodüksiyonlar.
          </p>
          <p>
            Yaklaşımım hibrit: analog preamplar (Sestream, API 500, TLA Ivory 2) ve outboard rack
            (UREI 1176 Compressor) karakter için; dijital sinyal işleme ise cerrahi kontrol için.
            Sonuç, kağıt üzerindeki değerler değil, radyoda ve kulaklıkta duygusu değişmeyen bir mix.
          </p>
          <p>
            Her proje benim için özel — bu yüzden her siparişte 2 ücretsiz revizyon dahildir ve
            müşteri tarafından geribildirim isteği bittiğinde bitmiş sayılır.
          </p>

          <div className="grid grid-cols-3 gap-4 pt-4 max-w-lg">
            {[
              { n: "5M+", l: "Toplam Stream" },
              { n: "100+", l: "Prodüksiyon" },
              { n: "10+", l: "Yıl Tecrübe" },
            ].map((s, i) => (
              <div key={i} className="panel p-4">
                <div className="font-display text-2xl font-bold text-white">{s.n}</div>
                <div className="mono-caps mt-1 text-slate-400">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-16 panel overflow-hidden">
        <img src={console_img} alt="mixing console" className="w-full h-[420px] object-cover" />
      </div>
    </main>
  );
}
